<template>
  <div>
    <Lynx-Label label="Status" />
    <Treeselect
      :multiple="false"
      :options="listaStatus"
      placeholder="Selecione o status"
      v-model="internalStatus"
    />
  </div>
</template>
  
  <script>
import { listaStatus } from "@/utils/enums/statusDatas";
import Treeselect from "@riophae/vue-treeselect";

export default {
  name: "FiltroStatus",
  components: { Treeselect },
  props: {
    value: {
      required: true,
    },
    retirarDefinitivo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalStatus: this.value, // Inicializa com o valor do v-model
      listaStatus: listaStatus.filter(
        (status) =>
          status.id !== 1 || (status.id === 1 && !this.retirarDefinitivo)
      ),
    };
  },
  watch: {
    // Observa mudanças no valor interno e emite para o pai
    internalStatus(newValue) {
        // TODO: para vue 3 usar o código abaixo
    //   this.$emit("update:value", newValue);
        this.$emit("input", newValue);
    },
    // Observa mudanças no valor do v-model e atualiza internamente
    modelValue(newValue) {
      this.internalStatus = newValue;
    },
  },
};
</script>
  